import { DataSource } from "../../General/DataSource";
import { FirebaseData } from "../../General/FirebaseData";

export class CollectionItemTemplateData extends FirebaseData {

  name: string = "";
  fields: {
    [key: string]: DataSource;
  } = {};

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";

    this.fields = {};
    if (typeof data.fields === "object") {
      for (const key of Object.keys(data.fields)) {
        const dataSource = DataSource.getDataSource(data.fields[key]);
        if (dataSource) {
          this.fields[key] = dataSource;
        }
      }
    }

    super.setup(data);
  }
}